<div class="main d-flex gap-8 align-center just-space">
        <div class="rect-oval d-flex d-gap7" misToolTip data-html="true"
                [text]="'Capacity: '+attendance.totalCapacity+' | Boarded: '+attendance.plannedemployeesBoarded+' | Yet to Board: '+attendance.totalPlannedEmployeesToBoard+' | Spare Seats: '+(spareSeats) "
                [position]="'right'">
                <div class="h8 grey attendance-data d-flex"><img src="{{imgSrc}}assets/icons/total-cap.svg" /><span
                                class="text-black">{{attendance.totalCapacity}}</span></div>
                <span class="attendance-seperator text-grey">|</span>
                <div class="h8 grey attendance-data d-flex"><img style="margin-right: 6px;"
                                src="{{imgSrc}}assets/icons/plan-boarded.svg" /><span
                                class="text-black">{{attendance.plannedemployeesBoarded}}</span></div>
                <span class="attendance-seperator d-flex text-grey">|</span>
                <div class="h8 grey attendance-data d-flex"><img style="margin-right: 6px;"
                                src="{{imgSrc}}assets/icons/plan-yet-b.svg" /><span
                                class="text-black">{{attendance.totalPlannedEmployeesToBoard}}</span></div>
                <span class="attendance-seperator text-grey">|</span>
                <div class="h8 grey attendance-data d-flex"><img style="margin-right: 6px;"
                                src="{{imgSrc}}assets/icons/add-white.svg" /><span
                                class="text-black pl-2">{{spareSeats}}</span>
                </div>
        </div>

        <div class="rect-oval d-flex d-gap8 just-center" style="min-width: 150px;" misToolTip
                [text]="'Planned: '+(attendance.totalPlannedEmployeesToBoard+attendance.plannedemployeesBoarded+attendance.noShowCount) +' | Signed In: '+(attendance.plannedemployeesBoarded+attendance.adhocCount)+' | No Show: '+attendance.noShowCount"
                [position]="'bottom'">
                <div class="h8 grey attendance-data d-flex text-black"><img style="margin-right: 6px;"
                                src="{{imgSrc}}assets/icons/planned.svg" />
                        {{attendance.totalPlannedEmployeesToBoard+attendance.plannedemployeesBoarded+attendance.noShowCount}}</div>
                <span class="attendance-seperator text-grey">|</span>
                <div class="h8 grey attendance-data d-flex"><img style="margin-right: 6px;"
                                src="{{imgSrc}}assets/icons/sign-in.svg" /><span
                                class="text-black">{{attendance.plannedemployeesBoarded+attendance.adhocCount}}</span>
                </div>
                <span class="attendance-seperator text-grey">|</span>
                <div class="h8 grey attendance-data d-flex"><img style="margin-right: 6px;"
                                src="{{imgSrc}}assets/icons/no-show1.svg" /><span
                                class="text-black">{{attendance.noShowCount}}</span>
                </div>
        </div>


        <div class="rect-oval d-flex d-gap8" style="min-width: 70px;">
                <div class="h8 grey attendance-data text-black" style="margin: auto;">AdHoc {{attendance.adhocCount}}
                </div>
        </div>


        <!-- <div class="chip"><span class="h8">Planned </span><span class="h8-b">{{attendance.plannedemployeesBoarded}}/{{attendance.totalPlannedEmployeesToBoard}}</span></div>
    <div class="chip"><span class="h8 red">No Show </span><span class="h8-b red">{{attendance.noShowCount}}</span></div>
    <div class="chip"><span class="h8">Ad hoc </span><span class="h8-b">{{attendance.adhocCount}}</span></div> -->
        <div misToolTip [text]="'Employee Attendance report'" class="report-btn" [position]="'right'" style="cursor: pointer;"> <button
                        (click)="openModal()" class="transparent-button pointer-cursor"><img
                                src="{{imgSrc}}assets/icons/report.svg"></button></div>
</div>